<template>
<div class="dropdown">
	<div class="dropdown__icon" @click.stop="show">
		<slot name="icon"></slot>
	</div>
	<div class="dropdown__items" v-click-outside="hide" :class="{active: showDropdown}">
		<slot name="items"></slot>
	</div>
</div>
</template>

<script>
import Vue from 'vue'

Vue.directive('click-outside', {
  bind: function (el, binding, vnode) {
    window.event = function (event) {
      if (!(el == event.target || el.contains(event.target))) {
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener('click', window.event)
  },
  unbind: function (el) {
    document.body.removeEventListener('click', window.event)
  },
});

export default {
	data() {
		return {
			showDropdown: false
		}
	},
	methods: {
		show: function() {
			this.showDropdown = true;
		},
		hide: function() {
			this.showDropdown = false;
		}
  	}
}
</script>

<style lang="scss" scoped>
@import '../styles/variables.scss';

.dropdown {
	position: relative;
	transition: fill 250ms;
	user-select: none;

	&__icon {
		width: 25px;
		height: 25px;
		fill: #757575;
		cursor: pointer;

		&:hover {
			fill: $main-blue;
		}
	}

	&__items {
		opacity: 0;
		position: fixed;
		overflow: hidden;
		top: 70px;
		right: 25px;
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		min-height: 100px;
		border-radius: 4px;
		background-color: $form-grey;
		border: 1px solid $form-grey;
		box-shadow: 0px 5px 7px -1px rgba(0, 0, 0, 0.25);
		user-select: none;
		pointer-events: none;

		&.active {
			opacity: 1;
			pointer-events: all;
		}

		.dark & {
			background-color: $bg-black;
			border: 1px solid $dark-text;
		}
	}
}
</style>
